import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie'

import coinsList from '../../../utils/coinsList.json';
import CustomDropdown from "../../subcomponents/CustomDropdown";
import { RiDeleteBack2Line } from "react-icons/ri";
import { IoIosAddCircleOutline } from "react-icons/io";
import { BsPlusSquareFill } from "react-icons/bs";
import { TiDelete } from "react-icons/ti";

import  useUserSettingStore  from '../../../stores/UserSettingsStore'
import  useUserStore  from '../../../stores/UserStore'

const targetList = Object.values(coinsList).sort();


function MobileUserSettings() {

    const fetchUserSettings = useUserSettingStore((state) => state.fecthUserSettings)
    const userTargets = useUserSettingStore((state) => state.targets)

    // const [targetEntries, setTargetEntries] = useState([{ target: "", amount: "" }]);
    const [filledInput, setFilledInput] = useState({})
    const [targets, setTargets] = useState()

    // const handleChange = (e, index) => {
    //     const { name, value } = e.target;
    //     console.log('')
    //     if (name === 'target' || name === 'amount') {
    //       const values = [...targetEntries];
    //       values[index][name] = value;
    //       setTargetEntries(values);
    //       updateTargets(values);
    //     } else {
    //       setFilledInput((prevState) => ({
    //         ...prevState,
    //         [name]: value,
    //       }));
    //     }
    //   };
    //   const updateTargets = (values) => {
    //     const targetsString = values
    //       .filter(item => item.target && item.amount)
    //       .map(item => `${item.target}:${item.amount}`)
    //       .join('\n');
    //       setFilledInput(prevState => ({ ...prevState, targets: targetsString }));
    //   };
      const handleTargetsChange = (e) => {
        setTargets(e.target.value)
    }
    //   const handleAddTarget = () => {
    //     setTargetEntries([...targetEntries, { target: "", amount: "" }]);
    //   };
    
    //   const handleRemoveTarget = (index) => {
    //     const values = [...targetEntries];
    //     values.splice(index, 1);
    //     setTargetEntries(values);
    //     updateTargets(values);
    //   };
    //   const handleDropdownChange = (value, index) => {
    //     const values = [...targetEntries];
    //     values[index]['target'] = value;
    //     setTargetEntries(values);
    //     updateTargets(values);
    //   };
    //   const handleTargetsChange = (e) => {
    //     setTargets(e.target.value)
    // }
      const addtargets = async(e) => {
        const token = Cookies.get('token')
        const setting = e.currentTarget.getAttribute('setting_name');
        const data = {
            'req_type': "add",
            "setting": setting,
            "data": targets
        }
        console.log('ADD DAT', data)
        try {
            await axios({
            headers: { Authorization: token },
            method: "POST",
            url : "api/make_user_settings",
            data : data
            })
            setTargets()
            } catch (err) {
            if (err.response.status === 401){                
                useUserStore.getState().logOut()    
            }              
        } 
      }
      const deleteOne = async(e) => {
        const token = Cookies.get('token')
        const value = e.currentTarget.getAttribute('data-id');
        const setting = e.currentTarget.getAttribute('setting_name');
        const data = {
            "req_type": "delete_one", 
            'data': value,
            "setting": setting
        }
        try {
            await axios({
            headers: { Authorization: token },
            method: "POST",
            url : "api/make_user_settings",
            data : data
            })
            } catch (err) {
            if (err.response.status === 401){                
                useUserStore.getState().logOut()    
            }                 
        } 
    
      }
      const deleteAll = async(e) => {
        const token = Cookies.get('token')
        const value = e.target.name 
        const data = {
            "req_type": "delete_all",
            'setting': value,
        }
        try {
            await axios({
            headers: { Authorization: token },
            method: "POST",
            url : "api/make_user_settings",
            data : data
            })
            } catch (err) {
            if (err.response.status === 401){                
                useUserStore.getState().logOut()    
            }                 
        } 
      }

  return (
    <div className='mobile_subcontainer'>
       
        {/* {targetEntries.map((entry, index) => (
            <div className="mobile_target_input_container" key={index}>
               <input className="mobile_taget_amount_input input" type="number" name="amount" placeholder="Enter Amount" value={entry.amount} onChange={(event) => handleChange(event, index)} />
              <CustomDropdown options={targetList} value={entry.target} onChange={(value) => handleDropdownChange(value, index)} placeholder="Enter or select coin"/>
             
              <button className="btn" onClick={() => handleRemoveTarget(index)} >
                <RiDeleteBack2Line className='remove_target_icon'/>
              </button>
              
            </div>
        ))} */}
        
              <div className='user_targets_input_container'>     
                  <textarea rows="4" cols="40"  className='input user_setting_textarea' placeholder='BTCUSDT:1000 ETHUSDT:500, BTCUSDT:500 ETHUSDT:250,' setting_name='targets' type="text" value={targets || ""} onChange={(e) => handleTargetsChange(e)} onKeyDown={(e) => {if (e.key === "Enter") {addtargets(e);}}}/>
                  <BsPlusSquareFill  className="user_setting_add_icon" setting_name='targets' onClick={(e) => addtargets(e)} size={18}/>
              </div>
        {/* <button onClick={handleAddTarget} className='btn add_target_btn'><IoIosAddCircleOutline className='add_target_icon'/></button> */}

        {/* <button className='submit_user_targets_btn btn' setting_name='targets'  onClick={(e) => addtargets(e)}>Submit</button> */}
        
        <div className="user_setting_list_container">
          {userTargets && userTargets.length !== 0 ?
            <button className="btn clear_button" name="targets" onClick={(e) => deleteAll(e)}>Clear</button>
            : null
          }
          <div className="user_setting_list">
            {userTargets && userTargets.map(userTarget => {
              return (
                <li className='li' key={"user_setting_size_" + userTarget}>
                    {userTarget.split(' ').map(pair => {
                      console.log('USERTAR', userTarget)
                        const parts = pair.split(':');
                        const coinPair = parts[0];
                        const value = parseFloat(parts[1]).toLocaleString();

                        return (
                            <div key={pair}>
                                <p>{coinPair}: {value}</p>
                                
                            </div>
                        );
                    })}
                    <TiDelete data-id={userTarget} className='delete_user_setting_icon' setting_name="targets" onClick={(e) => deleteOne(e)} size={20} />
                </li>
              );
            })}    
          </div>
        </div>
    </div>
  )
}

export default MobileUserSettings